document.addEventListener("DOMContentLoaded", function () {
  // Carrier tab switching
  const carrierTabs = document.querySelectorAll(".carrier-tab");
  const carrierContents = document.querySelectorAll(".carrier-content");

  carrierTabs.forEach((tab, index) => {
    tab.addEventListener("click", function () {
      const carrierHandle = this.getAttribute("data-carrier");
      const isFirst = index === 0;
      const isLast = index === carrierTabs.length - 1;

      // Update active tab styles - make all inactive
      carrierTabs.forEach((t, i) => {
        // Remove all styles first
        t.classList.remove(
          "bg-primary",
          "text-white",
          "bg-white",
          "text-neutral-500",
          "border",
          "border-r",
          "border-l",
          "border-primary",
          "border-black/60",
          "rounded-l-lg",
          "rounded-r-lg"
        );

        // Add inactive styles
        t.classList.add("bg-white", "text-neutral-500");
      });

      // Apply borders based on which tab is active
      if (isFirst) {
        // First tab (Royal Mail) is active
        carrierTabs[0].classList.remove("bg-white", "text-neutral-500");
        carrierTabs[0].classList.add(
          "bg-primary",
          "text-white",
          "border",
          "border-r",
          "!border-r-0",
          "border-primary",
          "rounded-l-lg"
        );

        carrierTabs[1].classList.add(
          "border",
          "border-l",
          "!border-l-0",
          "border-black/60",
          "rounded-r-lg"
        );
      } else {
        // Second tab (DHL) is active
        carrierTabs[0].classList.add(
          "border",
          "border-r",
          "!border-r-0",
          "border-black/60",
          "rounded-l-lg"
        );

        carrierTabs[1].classList.remove("bg-white", "text-neutral-500");
        carrierTabs[1].classList.add(
          "bg-primary",
          "text-white",
          "border",
          "border-l",
          "!border-l-0",
          "border-primary",
          "rounded-r-lg"
        );
      }

      // Show/hide carrier content
      carrierContents.forEach((content) => {
        if (content.getAttribute("data-carrier") === carrierHandle) {
          content.classList.remove("hidden");
        } else {
          content.classList.add("hidden");
        }
      });
    });
  });

  // Zone collapse/expand
  const zoneHeaders = document.querySelectorAll(".zone-header");

  zoneHeaders.forEach((header) => {
    header.addEventListener("click", function () {
      const zoneId = this.getAttribute("data-zone-toggle");
      const content = document.querySelector(`[data-zone-content="${zoneId}"]`);
      const arrow = this.querySelector(".zone-arrow");
      const isExpanded = this.getAttribute("aria-expanded") === "true";

      if (isExpanded) {
        content.style.display = "none";
        arrow.style.transform = "rotate(180deg)";
        this.setAttribute("aria-expanded", "false");
      } else {
        content.style.display = "block";
        arrow.style.transform = "rotate(0deg)";
        this.setAttribute("aria-expanded", "true");
      }
    });
  });
});
